/* eslint-disable */
import React, { Component } from "react";
import { Card, Container, Row, Col, InputGroup, Button } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { connect } from "react-redux";
import { SuperAdminAction, PlateValidate } from "../../Actions";
import CustomContentAlert, { tableHeightScrollBars } from "../helper";
import Loader from "../Loader/Loader";
import { Translation } from "react-i18next";
import { Dropdown } from "react-bootstrap";
import DeleteDiscountModal from "../Modal/DeleteDiscountModal";
class ManagePlateValidate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validAddLotName: true,
      action: "Update/Delete",
      formIsValid: false,
      lotName: [],
      addLot: false,
      addNewLot: "",
      lots_: [],
      quick_permits: false,
      show_lot: true,
      plate_validate: false,
      visitor_lot: false,
      property_id: "",
      show_alert: false,
      show_error: false,
      api_success_message: "",
      api_error_message: "",
      isNextButtonDisable: false,
      isThereVisitorLot: false,
      show_visitor_alert: false,
      all_properties: [],
      columnsDataRender: 0,
      loader: false,
      showClearDiscountModal: false,
      rowPendingClear: null,
    };
    this.addActionRef = React.createRef();
  }

  componentDidMount = async () => {
    this.setState({
      loader: true, // Show loader immediately
    });
    try {
      // Pass the selected_Property ID to the action
      await this.props.getPlateValidatePermits(this.props.selectedPropertyId);
      this.setState({
        lots_: this.props.plateValidatePermitsData || [],
        loader: false,
      });
    } catch (error) {
      console.error("ManagePlateValidate: Error in componentDidMount during API call:", error); // Log 7
      this.setState({ loader: false, show_error: true, api_error_message: "Failed to load data. Please try again." });
      this.hideAlert();
    }//This finally block ensures that the loader is hidden to ensure that if there are no records to display the loading spinner is hidden.
      finally {
        this.setState({ loader: false });
     }
    
  };

  componentDidUpdate = (prevProps) => {
    if (JSON.stringify(this.props.plateValidatePermitsData) !== JSON.stringify(prevProps.plateValidatePermitsData)) {
      this.setState(
        {
          lots_: this.props.plateValidatePermitsData || [],
          loader: false, // Hide loader here when data is successfully received
        },
        () => {
          const visitorLot = (this.state.lots_ ?? []).filter((item) => item.visitor_lot === true);
          const isNextButtonDisable = !(this.state.lots_.length > 0);
          const isThereVisitorLot = !!(visitorLot.length > 0);
          this.setState({
            isNextButtonDisable: isNextButtonDisable,
            isThereVisitorLot: isThereVisitorLot,
          });
        },
      );
    }
  };

  handleVisitorLotChange = async (e, editData, props = null) => {
    e.preventDefault();
    if (editData.id) {
      
      editData.visitor_lot = !editData.visitor_lot;
      await this.props.editLot({ 
        ...editData,
      });
      if (this.props.api_response) {
        this.setState({
          show_alert: true,
          api_success_message: this.props.api_success_message,
        });
        this.hideAlert();
        // Re-fetch data to ensure table is up-to-date after edit
        await this.props.getPlateValidatePermits(this.props.selectedPropertyId);

        // Manually update local state regardless of shallow prop change
        this.setState({
          lots_: this.props.plateValidatePermitsData || [],
        });
      } else {
        this.setState({
          show_error: true,
          api_error_message: this.props.api_error_message,
        });
        setTimeout(() => {
          this.setState({ show_error: false });
        }, 4000);
      }
    } else {
      const updated = !this.state.visitor_lot;

      if (props?.onChange) {
        props.onChange(updated);
      }

      this.setState({
        visitor_lot: updated,
        quick_permits: false,
      });
    }
  };

  hideAlert = () => {
    setTimeout(() => {
      this.setState({
        show_alert: false,
      });
    }, 4000);
  };

  handlePermitActiveChange = async (e, rowData) => {
    e.preventDefault();

    const isDeactivating = rowData.plate_validate_active === 1 || rowData.plate_validate_active === true;
    const action = isDeactivating ? "deactivate" : "activate";

    try {
      await this.props.updatePermitStatus({
        action,
        lot_id: rowData.id,
        property_id: rowData.property_id,
        user_id: this.props.userId,
      });

      if (this.props.api_response) {
        this.setState({
          show_alert: true,
          api_success_message: this.props.api_success_message,
        });
      } else {
        this.setState({
          show_error: true,
          api_error_message: this.props.api_error_message,
        });
      }

      this.hideAlert();

      await this.props.getPlateValidatePermits(this.props.selectedPropertyId);
      this.setState({ lots_: [...this.props.plateValidatePermitsData] }); // Force render
    } catch (error) {
      this.setState({
        show_error: true,
        api_error_message: "Failed to update permit status.",
      });
      this.hideAlert();
    }
  };

  handleQuickPermitChange = async (e, editData, props = null) => {
    if (editData.id) {
      editData.quick_permits = !editData.quick_permits;
      await this.props.editLot({ // This action should update the 'lots' table
        ...editData,
      });
      if (this.props.api_response) {
        this.setState({
          show_alert: true,
          api_success_message: this.props.api_success_message,
          columnsDataRender: 1,
        });
        this.hideAlert();
        await this.props.getPlateValidatePermits(this.props.selectedPropertyId);
      } else {
        this.setState(
          {
            show_error: true,
            api_error_message: this.props.api_error_message,
          },
          () =>
            this.setState({
              columnsDataRender: 1,
            }),
        );
        setTimeout(() => {
          this.setState({ show_error: false });
        }, 4000);
      }
    } else {
      const updated = !this.state.quick_permits;

      if (props?.onChange) {
        props.onChange(updated);
      }

      this.setState({
        quick_permits: updated,
        visitor_lot: false,
      });
    }
  };

  handleshowLotChange = async (e, editData) => {
    e.preventDefault();
    if (editData.id) {
      editData.show_lot = !editData.show_lot;
      await this.props.editLot({
        ...editData,
      });
      if (this.props.api_response) {
        this.setState({
          show_alert: true,
          api_success_message: this.props.api_success_message,
          columnsDataRender: 1,
        });
        this.hideAlert();
        await this.props.getPlateValidatePermits(this.props.selectedPropertyId);
      } else {
        this.setState(
          {
            show_error: true,
            api_error_message: this.props.api_error_message,
          },
          () =>
            this.setState({
              columnsDataRender: 1,
            }),
        );
        setTimeout(() => {
          this.setState({ show_error: false });
        }, 4000);
      }
    } else {
      this.setState({
        show_lot: !this.state.show_lot,
      });
    }
  };

  HandleErrorSuccess = (resolve, reject) => {
    if (resolve && this.props.api_response) {
      resolve();
    } else {
      if (reject && this.props.api_error_message) {
        reject(new Error(this.props.api_error_message));
      }
    }
  };

  handleAddLot = async (newData, resolve, reject) => {
    // This function creates a new LOT, which is consistent with the new table focus
    const lotData = {
      alias: newData.alias,
      visitor_lot: this.state.visitor_lot,
      quick_permits: this.state.quick_permits,
      show_lot: this.state.show_lot,
      plate_validate: newData.plate_validate,
      property_id: this.props.selectedPropertyId,
    };

    await this.props.createLot(lotData); // This action should create a new record in the 'lots' table
    this.HandleErrorSuccess(resolve, reject);
    if (this.props.api_response) {
      this.setState({
        show_alert: true,
        api_success_message: this.props.api_success_message,
        visitor_lot: false,
        columnsDataRender: 1,
        quick_permits: false,
        show_lot: false,
        plate_validate: false,
      });
      setTimeout(() => {
        this.setState({
          show_alert: false,
        });
      }, 4000);
      await this.props.getPlateValidatePermits(this.props.selectedPropertyId);
    } else {
      this.setState({
        show_error: true,
        api_error_message: this.props.api_error_message,
        visitor_lot: false,
        columnsDataRender: 1,
        quick_permits: false,
        show_lot: false,
        plate_validate: false,
      });
      setTimeout(() => {
        this.setState({ show_error: false });
      }, 4000);
    }
  };

  handleEditLot = async (editData, resolve, reject) => {
    // This function edits an existing LOT, which is consistent with the new table focus
    await this.props.editLot({ // This action should update an existing record in the 'lots' table
      ...editData,
    });
    this.HandleErrorSuccess(resolve, reject);
    if (this.props.api_response) {
      this.setState({
        show_alert: true,
        api_success_message: this.props.api_success_message,
        columnsDataRender: 1,
      });
      setTimeout(() => {
        this.setState({
          show_alert: false,
        });
      }, 4000);
      await this.props.getPlateValidatePermits(this.props.selectedPropertyId);
    } else {
      this.setState({
        show_error: true,
        api_error_message: this.props.api_error_message,
        columnsDataRender: 1,
      });
      setTimeout(() => {
        this.setState({ show_error: false });
      }, 4000);
    }
  };

  handleDeletePlateValidateDiscount = async (rowData) => {
    const lotId = rowData.id;
    const propertyId = rowData.property_id;
    const userId = this.props.userId;

    try {
      const response = await this.props.deletePlateValidateDiscount({
        property_id: propertyId,
        lot_id: lotId,
        user_id: userId,
      });

      if (response && response.success === 1) {
        this.setState({
          show_alert: true,
          api_success_message: response.message || "Discount deleted successfully!",
        });

        // Optionally refresh the lot data after discount deletion
        await this.props.getPlateValidatePermits(this.props.selectedPropertyId);
        this.setState({
          lots_: this.props.plateValidatePermitsData || [],
        });
      } else {
        this.setState({
          show_error: true,
          api_error_message: response.message || "Failed to delete discount.",
        });
      }
    } catch (error) {
      console.error("Error deleting discount:", error);
      this.setState({
        show_error: true,
        api_error_message: "An error occurred while deleting discount.",
      });
    }

    this.hideAlert();
  };

  handleAlertOnVisitorLot = () => {
    const { isThereVisitorLot } = this.state;
    if (!isThereVisitorLot) {
      this.setState({
        show_visitor_alert: true,
      });
    }
    setTimeout(() => {
      this.setState({
        show_visitor_alert: false,
      });
    }, 4000);
  };

  editVisitorLot = (props) => {
    const isCreateMode = !props?.rowData?.id;
    const current = isCreateMode ? this.state.visitor_lot : props.rowData.visitor_lot || false;

    return (
      <InputGroup>
        <InputGroup.Checkbox
          name="visitor_lot"
          checked={current}
          onChange={(e) => this.handleVisitorLotChange(e, props.rowData, props)}
          aria-label="visitor_lot"
        />
      </InputGroup>
    );
  };

  editQuickPermits = (props) => {
    const isCreateMode = !props?.rowData?.id;
    // quick_permits is now a property of the lot itself
    const current = isCreateMode ? this.state.quick_permits : props.rowData.quick_permits || false;

    return (
      <InputGroup>
        <InputGroup.Checkbox
          name="quick_permits"
          checked={current}
          onChange={(e) => this.handleQuickPermitChange(e, props.rowData, props)}
          aria-label="quick_permits"
        />
      </InputGroup>
    );
  };

  showLot = (props) => {
    // show_lot is now a property of the lot itself
    const checkedValue = Object.keys(props?.rowData).length && "show_lot" in props.rowData ? props.rowData.show_lot : this.state.show_lot;
    return (
      <InputGroup>
        <input type="checkbox" name="show_lot" checked={checkedValue} onChange={(e) => this.handleshowLotChange(e, props.rowData)} aria-label="show_lot" />
      </InputGroup>
    );
  };

  handleComponentsActionField = (props) => {
    if (typeof props.action === typeof Function || props.action.tooltip !== "Add") {
      return <MTableAction {...props} />;
    } else {
      return <div ref={this.addActionRef} onClick={props.action.onClick} />;
    }
  };

  handleIconAddField = (props) => (
    <Button className="btn-blue-bg" data-mycustomid={"add-icon-handler"}>
    </Button>
  );

  onLotRowAdd = (newData) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (newData.alias) {
          this.handleAddLot(newData, resolve, reject);
          resolve();
        } else {
          reject(Error);
          this.setState({
            show_error: true,
            api_error_message: "Name is mandatory",
          });
          setTimeout(() => {
            this.setState({ show_error: false });
          }, 4000);
        }
      }, 1000);
    });
  };

  onLotRowUpdate = (newData) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        this.handleEditLot(newData, resolve, reject);
        resolve();
      }, 1000);
    });
  };

  renderActiveButton = (rowData) => {
    const isActive = rowData.plate_validate_active;

    return (
      <Button
        className="btn-fill text-nowrap"
        variant={isActive ? "danger" : "success"}
        size="xs"
        style={{ width: "80px" }} // ensure same width for both buttons
        onClick={(e) => this.handlePermitActiveChange(e, rowData)}
      >
        <Translation>
          {(t) => <>{t(isActive ? "Deactivate" : "Activate")}</>}
        </Translation>
      </Button>
    );
  };

  confirmClearDiscountModal = (rowData) => {
    const data = {
      title: "Remove Discount",
      message: `Note: Removing this discount will permanently delete the discount from "${rowData.alias}" and from all associated permits. Do you want to continue?`,
    };
    this.setState({
      showClearDiscountModal: true,
      rowPendingClear: rowData,
      confirmClearDiscountData: data,
    });
  };

  formatDiscountType = (rawType) => {
    if (!rawType || typeof rawType !== "string") return "-";
    const typeMap = {
      PERCENTAGE: "Percentage",
      TIME_CREDIT: "Time Credit",
      FIXED_COST: "Fixed Cost",
      FIXED_DISCOUNT: "Fixed Discount",
    };
    return typeMap[rawType] || rawType
      .toLowerCase()
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  formatTimeCredit = (minutes) => {
    if (isNaN(minutes) || minutes === null) return "-";
    const hrs = Math.floor(minutes / 60);
    const mins = minutes % 60;
    if (hrs > 0 && mins > 0) return `${hrs}h ${mins}m`;
    if (hrs > 0) return `${hrs}h`;
    return `${mins}m`;
  };

  formatDiscountValue = (row) => {
    if (!row) return "-";
    const { discount_type, discount_amount } = row;
    if (discount_amount === undefined || discount_amount === null || discount_amount === "") return "-";

    switch (discount_type) {
      case "FIXED_COST":
      case "FIXED_DISCOUNT":
        return `$${parseFloat(discount_amount).toFixed(2)}`;
      case "TIME_CREDIT":
        return this.formatTimeCredit(Number(discount_amount));
      default:
        return discount_amount;
    }
  };

  get columns() {
    return [
      {
        name: "Lot",
        sortable: true,
        minWidth: "130px",
        selector: (row) => row.alias,
        cell: (row) => row?.alias ?? "-",
      },
      {
        name: "Discount Type",
        sortable: true,
        allign: "center",
        minWidth: "150px",
        // REMOVED: width: "380px",
        // REMOVED: maxWidth: "150px",
        selector: (row) => row.discount_type,
        cell: (row) => (
          <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
            {this.formatDiscountType(row.discount_type)}
          </div>
        ),
      },
      {
        name: "Discount Value",
        sortable: true,
        minWidth: "120px",
        selector: (row) => Number(row.discount_amount) || 0,
        cell: (row) => <div style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>{this.formatDiscountValue(row)}</div>,
        headerStyle: { textAlign: 'center' },
        style: { textAlign: 'center' },
      },
      {
        name: "Status",
        sortable: false,
        center: true,
        minWidth: "100px",
        cell: (row) =>
          row.plate_validate_active === 1 || row.plate_validate_active === true
            ? "Active"
            : "Deactivated",
      },
      {
        name: "Activation",
        sortable: false,
        // REMOVED: width: "140px",
        center: true,
        cell: (row) => this.renderActiveButton(row),
      },
      {
        name: "Action",
        sortable: false,
        center: true,
        // REMOVED: width: "120px",
        cell: (row) => (
          <Dropdown drop="down">
            <Dropdown.Toggle variant="Primary" id={`dropdown-${row.id}`} className="btn-xs">
              Action
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item className="text-sm text-secondary" onClick={() => this.confirmClearDiscountModal(row)}>
                Clear Discount
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        ),
      },
    ];
  }

  render() {
    const { lots_, show_alert, show_error, show_visitor_alert, columnsDataRender, loader } = this.state;


    return (
      <div>
        <Container fluid>
          <Row>
            <Col md="12">
              <Card className="mb-0">
                <Card.Header>
                  <div className="d-flex align-items-sm-center align-items-start justify-content-between">
                    <div>
                      <Card.Title as="h4">Manage Plate Validate Permits</Card.Title>
                      <p className="card-category mb-0">
                        This page shows the lots that support PlateValidate.
                      </p>
                    </div>
                  </div>
                </Card.Header>
                <Card.Body>
                  {loader ? (
                    <Loader />
                  ) : (
                    <>
                      {lots_.length > 0 ? (
                        <div className="citation-list-table manage-permit-packages">
                          <DataTable
                            data={lots_}
                            columns={this.columns}
                            responsive
                            defaultSortAsc
                            fixedHeader
                            fixedHeaderScrollHeight={tableHeightScrollBars()}
                            pagination
                            paginationPerPage={20}
                            paginationRowsPerPageOptions={[20, 50, 100, 200]}
                          />
                        </div>
                      ) : (
                        <div className="text-center d-block">
                          <div>{`There are no records to display`}</div>
                        </div>
                      )}
                    </>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
          {this.state.showClearDiscountModal && (
            <DeleteDiscountModal
              showBrowserModal={this.state.showClearDiscountModal}
              details={this.state.confirmClearDiscountData}
              closeModal={() =>
                this.setState({ showClearDiscountModal: false, rowPendingClear: null })
              }
              handleSave={async () => {
                await this.handleDeletePlateValidateDiscount(this.state.rowPendingClear);
                this.setState({ showClearDiscountModal: false, rowPendingClear: null });
              }}
              handleCancel={() =>
                this.setState({ showClearDiscountModal: false, rowPendingClear: null })
              }
            />
          )}
        </Container>
        {show_alert ? <CustomContentAlert delay={4000} message={this.state.api_success_message} className="toast-success" /> : null}
        {show_error ? <CustomContentAlert delay={4000} message={this.state.api_error_message} className="toast-error" /> : null}
        {show_visitor_alert ? <CustomContentAlert delay={4000} message={"Please make atleast one visitor lot true"} className="toast-error" /> : null}
      </div>
    );
  }
}

const mapStateToProps = ({ SuperAdminDetails, APIResponseDetails, PlateValidateDetails, UserProfileDetails }) => {
  const { lots, getAllProperties } = SuperAdminDetails;
  const { property_id: selectedPropertyId, id: userId } = UserProfileDetails;
  const { api_response, api_success_message, api_error_message } = APIResponseDetails;
  const { plateValidatePermitsData } = PlateValidateDetails;
  return {
    lots,
    plateValidatePermitsData,
    getAllProperties,
    selectedPropertyId,
    api_response,
    api_success_message,
    api_error_message,
    userId,
  };
};

const mapStateToDispatch = {
  get_all_lots: SuperAdminAction.get_all_lots,
  createLot: SuperAdminAction.createLot,
  editLot: SuperAdminAction.editLot,
  deleteLot: SuperAdminAction.deleteLot,
  getPlateValidatePermits: PlateValidate.getPlateValidatePermits,
  updatePermitStatus: PlateValidate.updatePermitStatus,
  deactivatePermitsOnLotDelete: PlateValidate.deactivatePermitsOnLotDelete,
  get_all_properties: SuperAdminAction.get_all_properties,
  setDomainHeader: SuperAdminAction.setDomainHeader,
  deletePlateValidateDiscount: PlateValidate.deletePlateValidateDiscount,
};

export default connect(mapStateToProps, mapStateToDispatch)(ManagePlateValidate);
